import { ArrowRight, SearchCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/useI18n';
import { StoreBadges } from './StoreBadges';

export function HeroSection() {
  const { t } = useI18n();

  return (
    <section className="hero section-band">
      <div className="hero-copy">
        <p className="eyebrow">{t('hero.eyebrow')}</p>
        <h1>{t('hero.title')}</h1>
        <p className="lead">{t('hero.subtitle')}</p>
        <p className="support">{t('hero.support')}</p>
        <div className="hero-store-row">
          <StoreBadges />
        </div>
        <div className="cta-row hero-secondary-actions">
          <Link className="button secondary" to="/proof">
            <SearchCheck size={18} />
            {t('hero.verify')}
          </Link>
          <a className="button ghost" href="#how-it-works">
            {t('hero.how')}
            <ArrowRight size={18} />
          </a>
        </div>
        <div className="hero-paths" aria-label={t('hero.pathsLabel')}>
          <a href="#how-it-works">
            <strong>{t('hero.path.capture.title')}</strong>
            <span>{t('hero.path.capture.text')}</span>
          </a>
          <Link to="/proof">
            <strong>{t('hero.path.verify.title')}</strong>
            <span>{t('hero.path.verify.text')}</span>
          </Link>
          <a href="#recipient-view">
            <strong>{t('hero.path.share.title')}</strong>
            <span>{t('hero.path.share.text')}</span>
          </a>
        </div>
      </div>
      <div className="hero-visual" aria-label={t('hero.visualLabel')}>
        <img
          className="app-screen app-screen-main"
          src="/assets/app-screens/camera.jpg"
          alt={t('hero.visualCameraAlt')}
          width="655"
          height="1280"
          fetchPriority="high"
        />
        <img
          className="app-screen app-screen-secondary"
          src="/assets/app-screens/proof-result.jpg"
          alt={t('hero.visualProofAlt')}
          width="655"
          height="1280"
        />
      </div>
    </section>
  );
}
